module.exports = __webpack_public_path__ + "dfc040d53fa343d2ba7ccb8217f34346.woff";